exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cardTextBody {\n  min-height: 230px;\n}\n.imgHeight {\n  height: 165px;\n  object-fit: contain;\n}\n.Tcolor {\n  color: #00a09c;\n}\n", ""]);

// exports
